<template>
	<div>
		<app-app-header :title="$t('view.gtc.title')" :color="$config.public.colors.primary" v-model="indexStore.isHeaderVisible"/>

		<app-content>
			<page-content xs-full sm-full md-full lg-full>
				<feature-screen class="bg-white" hide-title-on-mobile :show-description="false" image="/views/gtc/spoferan-gtc.jpg" lang-prefix="view.gtc" top>
					<server-content :action="'/v1/settings/gtc'" as-guest access="value" skeleton="paragraph@50"/>
				</feature-screen>
			</page-content>
		</app-content>

		<app-footer :items="footerItems"/>

	</div>
</template>

<script setup lang="ts">

import {useIndexStore} from "../store";
import {useAppFooter} from "../composables/useAppFooter";

const {t} = useI18n();
const indexStore = useIndexStore();
const {$image} = useNuxtApp();
const {footerItems} = useAppFooter();

useMeta({
	title: t('view.gtc.title'),
	description: t('view.gtc.description'),
	image: $image.format('/views/gtc/spoferan-gtc.jpg', {width: 1200, height: 1200})
});

</script>

